export default "__VITE_ASSET__BWfTaqHb__"